import Dialog from "../1. Core/Controls/Dialog/Dialog";
import {LevelMetaInfo} from "./MetaLevelsListDialog";
import NumField from "../1. Core/Controls/TextField/NumField";
import {ServerAPI} from "../1. Core/ServerAPI";


export default class MetaLevelEditDialog extends Dialog {


	private _Item: LevelMetaInfo;

	private _koej: NumField;


	_initFields(settings: object)
	{
		this._Item = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = this._Item.name;
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
	}

	_render()
	{
		super._render();

		this._koej = new NumField({
			FloatingLabel: 'Value',
			FractionCount: 2,
			ParentNode: this._contentNode,
			Value: this._Item.borderValue,
			Min: 0.01,
			Max: 1,
			EvChanged: () =>
			{
				this._Item.borderValue = this._koej.getValue();
			}
		});

	}


	async _onOkButtonClick()
	{

		await ServerAPI.post(`/fantasy/updateMetaLevel`, this._Item);


		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}
